import DateFilter from 'components/brokers/needs_attention/DateFilter'
import { type SingleSelectedValueFilter } from 'components/brokers/types'

const AfterDateFilter = (props: SingleSelectedValueFilter) => {
  return <DateFilter {...props} rangeType='Greater than' />
}

export default AfterDateFilter
